export default __webpack_public_path__ + "static/loading-7f3f7a1a8ad5374d45625117322c71f7.gif";